var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeigniter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE4323;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "codeigniter"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.6,69.9c-3.3-1.4-5.5-4.4-5.8-8c0.2-3.6,2.1-6.9,5.2-8.8c-0.5,1.2-0.4,2.6,0.3,3.8 c0.8,1.1,2.2,1.6,3.5,1.4c3.1-0.7,3.2-4.2,1.4-6.1c-1.9-2-3.6-4.2-2.9-7c0.4-1.5,1.2-2.8,2.3-3.8c-0.9,2.3,1.6,4.5,3.2,5.6 c2.9,1.7,5.7,3.6,8.4,5.6c2.9,2.2,4.5,5.6,4.3,9.2c-0.7,3.9-3.5,7-7.2,8.2c7.5-1.7,15.3-7.5,15.5-15.9c0.1-6.9-4.6-12.2-10.4-15.2 L75,38.8c0.1,0.3,0.2,0.7,0.2,1c0-0.2,0-0.5,0-0.7c0,0.3,0,0.6,0,0.8v-0.2c-0.1,0.4-0.2,0.7-0.4,1l0.1-0.1 c-1.2,1.7-3.5,2.1-5.2,0.9c-0.2-0.2-0.5-0.4-0.6-0.6c-2.5-3.2,0-6.7,0.4-10.1c0.1-4.4-2-8.5-5.6-10.9c1.9,3-0.6,6.9-2.5,9.1 c-1.9,2.2-4.1,3.9-6.2,5.8c-2.2,2.1-4.2,4.3-6,6.7c-3.6,4.9-5.9,11-4.2,17.1C46.7,64.5,51.6,68.8,57.6,69.9L57.6,69.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeigniter);
export default __webpack_public_path__ + "static/media/Codeigniter.2b239c16ad84041ca7204e6fe4664df4.svg";
export { ForwardRef as ReactComponent };